import React, {Component} from 'react';
import Const from 'constants';
import {sortByProperty} from 'helpers/sorters';
import TeamExposure from 'components/organisms/non-controlled-hitter-stacking/components/team-exposure';
import {calcPercentage} from 'helpers/common-helper';

class BaseStackSummary extends Component {
    prepareGroups() {
        const {correlationStackingSettingsStateId, runSettings, rawLineups} = this.props;

        const stacking = runSettings.getRunSettingsByKey(correlationStackingSettingsStateId);

        if (isEmpty(stacking)) {
            return {};
        }

        const lineups = rawLineups.asArr();
        let groups = {};
        lineups.map((lineup) => {
            lineup.getTeamGroups().map((groupName) => {
                const [teamName, groupNumber] = groupName
                    .replace(Const.LP_TEAM_GROUP_PREFIX, '')
                    .split(Const.LP_ITEM_DELIMITER);

                if (!groupNumber) {
                    return;
                }

                if (!groups.hasOwnProperty(groupNumber)) {
                    groups[groupNumber] = {
                        teams: {},
                        playersQuantity: stacking.getPlayersQuantityByStackNumber(groupNumber),
                    };
                }

                if (!groups[groupNumber].teams.hasOwnProperty(teamName)) {
                    groups[groupNumber].teams[teamName] = {
                        teamName,
                        quantity: 0,
                    };
                }

                groups[groupNumber].teams[teamName].quantity++;
            });
        });

        Object.keys(groups).map((groupNumber) => {
            let teams = Object.values(groups[groupNumber].teams);
            teams.sort(sortByProperty('quantity', 'desc'));
            groups[groupNumber].teams = [...teams];
        });

        return {...groups};
    }

    countTeams(groups) {
        let teams = [];
        Object.values(groups).map((group) => {
            group.teams.map((item) => {
                if (!inArray(item.teamName, teams)) {
                    teams.push(item.teamName);
                }
            });
        });
        return teams.length;
    }

    getNotFoundView() {
        return (
            <table key={-1} className="table">
                <tbody>
                    <tr key="teams-not-found" className="empty">
                        <td>Teams were not found.</td>
                    </tr>
                </tbody>
            </table>
        );
    }

    getTeamStackView(teamNumber, stackNumber, groupItem) {
        const {rawLineups} = this.props;
        const percentage = calcPercentage(rawLineups.getQuantity(), groupItem.quantity);
        const className = teamNumber % 2 === 0 ? 'even' : '';

        return (
            <tr key={groupItem.teamName} className={className}>
                <td>
                    <strong>{groupItem.teamName}</strong>
                </td>
                <td className="text-blue">
                    {percentage}% ({groupItem.quantity})
                </td>
                <td>
                    <div className="percent-in">
                        <TeamExposure
                            team={groupItem.teamName}
                            exposureType="max"
                            stackNumber={stackNumber}
                            className="form-control small-table-input"
                        />
                        <span className="percent">%</span>
                    </div>
                </td>
            </tr>
        );
    }

    getTeamsStackView(groupNumber, stackGroup) {
        const rows = stackGroup.teams.map((item, i) => this.getTeamStackView(i, groupNumber, item));

        return (
            <table key={groupNumber} className="table">
                <thead>
                    <tr>
                        <th>{`${stackGroup.teams.length} Teams Used in Stack ${groupNumber}`}</th>
                        <th></th>
                        <th>
                            Exp.
                            <br />
                            max
                        </th>
                    </tr>
                </thead>
                <tbody>{rows}</tbody>
            </table>
        );
    }
}

export {BaseStackSummary};
